<template>
  <button
    id="btn"
    type="button"
    class="w-32 h-10 text-sm text-center uppercase"
    :style="{ background: disabled ? '#9CA3AF' : global.primaryColor, borderRadius: '5px'}"
    :class="{
      'opacity-60 cursor-not-allowed': disabled,
      'bg-blue-900': type === 'primary' && !disabled,
      'hover:bg-blue-800': type === 'primary' && !disabled,
      'text-white': type === 'primary',
      'bg-white': type === 'secondary' && !disabled,
      'hover:bg-gray-200': type === 'secondary' && !disabled,
      'text-black': type === 'secondary',
    }"
    :aria-disabled="disabled ? 'true' : 'false'"
    :aria-describedby="ariaDescribedby || undefined"
    :tabindex="disabled ? 0 : undefined"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick"
    @focus="handleFocus"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaDescribedby: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  methods: {
    handleClick(event: Event) {
      this.$emit('onClick');
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    handleFocus() {
      this.$emit('onFocus');
    }
  }
});
</script>

<style>
</style>
